/*============nav Controller
 ================================*/
angular
  .module('vppApp')
  .controller('navController', navController);

navController.$inject = ['$scope', 'navFactory', '$state', 'vppConfig', '$attrs', '$window', '$location', 'AuthenticationService', 'apiFactory', 'splitFilter', 'SetLiveSwapService', '$cookies'];

function navController($scope, navFactory, $state, vppConfig, $attrs, $window, $location, AuthenticationService, apiFactory, splitFilter, SetLiveSwapService, $cookies) {
  var _theNav = $attrs.theNav;
  var liveswap = SetLiveSwapService.getLSBrandName();
  var idMeWindow;
  var envID;
  $scope.isAuth = AuthenticationService.isAuthenticated();
  $scope.isAuthent = function () {
    return AuthenticationService.isAuthenticated();
  };

  //$scope.copyRight = vppConfig.reusableValues.currentYear;
  navFactory(_theNav).then(function (response) {
    var currentState = $state.current.name;
    if (currentState.indexOf('.') > -1) {
      var _tempStr = splitFilter($state.current.name, '.', 0);
      currentState = _tempStr;
    }

    console.log("currentState: ", currentState);

    $scope.navLinks = [];
    if (_theNav === "subNav") {
      getSubNav();
    } else {
      getNav();
    }

    function getSubNav() {
      for (var i = 0; i < response.data[_theNav].name.length; i++) {
        if (response.data[_theNav].name[i][currentState] !== undefined) {
          $scope.navLinks.push(response.data[_theNav].name[i][currentState]);
        }
      }
    }

    function getNav() {
      var navLinks = response.data[_theNav].name[0];
      var primeNav = [];
      for (var j = 0; j < navLinks.navigation.length; j++) {
        var navLink = navLinks.navigation[j];
        var liveswapHide = navLink.liveswap;
        if (navLink.isGC === "true") {
          envID = vppConfig.globalConnectSignIn[environment];
          navLink.externalLink = envID + navLink.externalLink;
        } else {
          envID = null;
        }
        if (liveswap && !liveswapHide) {
          primeNav.push(navLink);
        } else if (!liveswap) {
          primeNav.push(navLink);
        }
      }
      $scope.navLinks.push(primeNav);
    }
  });

  // Signout Controller
  $scope.submitSignOut = function () {
    apiFactory.signOut()
      .then(function successSignOut(response) {
        AuthenticationService.destroyAuthentication();
        if (response.data.url != null){
          $window.location.href = response.data.url;
        }
        // this callback will be called asynchronously
        // when the response is available
      }, function errorCallback(response) {
        // console.log(response.data.errors);
        $scope.serverError = response.data.errors;
        // called asynchronously if an error occurs
        // or server returns response with an error status.
      });
  };

  $scope.signInManage = function() {
        // if($cookies.get('showSignInNotice')){
        //   $window.location.href = $scope.ssoUrl;
        // } else{
        //   $state.go('sign-in-notice')
        // }

        $state.go('sign-in-notice')
  }

  $scope.gcSignIn = function() {
    apiFactory.gcVerify()
      .then(function successGCSignIn(response){
        if(response.data.url != null){
          var date = new Date();
          var expirationDate = new Date(date.setMonth(date.getMonth()+6));
          $cookies.put('createAccountDirect', false, {expires: expirationDate});

          $window.location.href = response.data.url;
        }else{
          $location.path("/saml/login/" + response.data.accountId);
        }
      }, function errorCallback(response){
        // console.log(response.data.errors);
        $scope.serverError = response.data.errors;
        // called asynchronously if an error occurs
        // or server returns response with an error status.
      });
  };

}